import { useState } from 'react';
import { useForgotPasswordMutation } from '../../api/authApi';
import { AlertUtils } from '../../../../shared/utils/alert';
import { useNavigate } from 'react-router-dom';

export function useForgotPasswordHook() {
  const [email, setEmail] = useState('');
  const [forgotPassword, { isLoading, isSuccess }] = useForgotPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      AlertUtils.toast('Please enter your email', 'warning');
      return;
    }

    try {
      await forgotPassword({ email }).unwrap();
      AlertUtils.toast('If that email exists in our system, you will receive a password reset link shortly.', 'success');
    } catch (err: any) {
      let errorMsg = err?.data?.message || err?.message || 'Failed to request password reset';
      if (err?.data?.errors && Array.isArray(err.data.errors) && err.data.errors.length > 0) {
        errorMsg = err.data.errors[0].message;
      }
      AlertUtils.toast(errorMsg, 'error');
    }
  };

  return {
    email,
    setEmail,
    isLoading,
    isSuccess,
    handleSubmit,
    navigate
  };
}
